import Header from "./Header";
import Footer from "./Footer";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get("https://kyrgyz-adventure-travel.com/api/v1/tours/blog/")
            .then(response => {
                if (response.data.results.length > 0) {
                    setPosts(response.data.results);
                }
            })
            .catch(error => console.error("Error loading blog posts: ", error));
    }, []);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="bg-dark min-h-screen">
            <Header isScrolled={isScrolled} />
            <div className="h-32" />

            <div className="container pb-20">
                <div className="flex flex-col items-center gap-4 mb-16">
                    <p className="font-unbounded text-gold text-xs uppercase tracking-widest">
                        Latest news
                    </p>
                    <h1 className="font-unbounded font-bold text-4xl md:text-5xl text-white text-center">
                        Blog
                    </h1>
                    <p className="font-manrope text-white/60 text-lg text-center max-w-xl mt-2">
                        Travel stories, tips and adventures from Kyrgyzstan
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {posts.map((post) => (
                        <div
                            key={post.id}
                            className="card-dark group overflow-hidden cursor-pointer"
                            onClick={() => navigate(`/blog/${post.id}`)}
                        >
                            <div className="relative overflow-hidden">
                                <img
                                    src={post.images[0]?.image}
                                    className="w-full h-56 object-cover transition-transform duration-700 group-hover:scale-105"
                                    alt={post.title}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-dark-card via-transparent to-transparent" />
                                <div className="absolute bottom-4 left-4">
                                    <span className="font-manrope text-white/60 text-xs">
                                        {new Date(post.created_at).toLocaleDateString('en-GB', {
                                            day: 'numeric', month: 'long', year: 'numeric'
                                        })}
                                    </span>
                                </div>
                            </div>
                            <div className="p-6">
                                <h2 className="font-unbounded font-bold text-white text-lg mb-3 line-clamp-2">
                                    {post.title}
                                </h2>
                                <p className="font-manrope text-white/60 text-sm line-clamp-3">
                                    {post.content}
                                </p>
                                <span className="inline-block mt-4 font-unbounded text-gold text-xs uppercase tracking-widest group-hover:underline">
                                    Read more →
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Blog;
